
import RecruitLinkList from '~/components/career/recruit-link-list.vue'

export default {
  name: 'RecruitLinks',
  components: {
    RecruitLinkList
  },
  props: {
    subtitle: {
      type: String,
      default: ''
    }
  }
}
